import config from '@/app/config'
import { MapRouteShell } from '@/app/shell/map-route-shell'
import { RouteStateProvider } from '@/app/state/route-state'
import { parseSearch } from '@/app/router/search-params'
import FloodSummaryPage from '@/features/flood-summary/components/FloodSummaryPage'
import { createFileRoute } from '@tanstack/react-router'
import React from 'react'

export const Route = createFileRoute('/flood-summary')({
  validateSearch: parseSearch,
  component: RouteComponent,
  head: () => ({
    meta: [
      { title: 'FloodNet NYC Flood Summary' },
      { name: 'description', content: 'Explore measured FloodNet flooding events across New York City over time.' },
    ],
  }),
})

function RouteComponent() {
  const search = Route.useSearch()
  const now = React.useMemo(() => new Date(), [])
  const from = React.useMemo(() => new Date(config.START_OF_PROJECT_TIME).toISOString(), [])
  const to = React.useMemo(() => new Date(now.getTime() + 2 * 24 * 60 * 60 * 1000).toISOString(), [now])

  if (search.embed === 1) {
    return (
      <RouteStateProvider routePath={Route.fullPath} search={search}>
        <FloodSummaryPage embedded chartMode={search.chartMode} />
      </RouteStateProvider>
    )
  }

  return (
    <MapRouteShell routePath={Route.fullPath} search={search} timeFrom={from} timeTo={to}>
      <FloodSummaryPage chartMode={search.chartMode} />
    </MapRouteShell>
  )
}
